import * as dateUtils from "shared/dateUtils";

let lastUserFetchTime: number | undefined;
const timeToWaitBetweenUserFetches = 30 * dateUtils.SECOND;

export function shouldFetchUser(): boolean {
  return (
    lastUserFetchTime === undefined ||
    Date.now() - lastUserFetchTime > timeToWaitBetweenUserFetches
  );
}

export function markUserFetched(): void {
  lastUserFetchTime = Date.now();
}

export function markUserStale(): void {
  lastUserFetchTime = undefined;
}
